import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { RegisterDetailCrubs } from 'practice/constants/practice-register-crubs';
import FormRegister, { FormRegisterVM } from 'practice/components/register/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeRegisterData } from 'shell/models/practice-lists';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { registerResponseTransformer } from 'practice/utils/metric-register-transformer';

const DetailRegister = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-registro');
  });

  const params = useParams();

  const [register] = useHttpFetch<HttpResponse<TypeRegisterData>, FormRegisterVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-registro/${params?.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: registerResponseTransformer,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={RegisterDetailCrubs} />
      {register.isLoading || register.pristine || register.hasErrors ? undefined : (
        <FormRegister
          title="Dettaglio Registro"
          disabled
          onCancel={onCancel}
          initialValues={register?.data as FormRegisterVM}
        />
      )}
    </Fragment>
  );
};

DetailRegister.displayName = 'Detail Register Page component';

export default DetailRegister;
